export const actions = {
  MENUS_LOAD_REQUESTED: 'MENUS_LOAD_REQUESTED',
  MENUS_LOAD_SUCCEEDED: 'MENUS_LOAD_SUCCEEDED',
  MENUS_LOAD_FILED: 'MENUS_LOAD_FILED',

  MENUS_LOAD_ALL_PARENTS_REQUESTED: 'MENUS_LOAD_ALL_PARENTS_REQUESTED',
  MENUS_LOAD_ALL_PARENTS_SUCCEEDED: 'MENUS_LOAD_ALL_PARENTS_SUCCEEDED',
  MENUS_LOAD_ALL_PARENTS_FILED: 'MENUS_LOAD_ALL_PARENTS_FILED',

  MENU_UPDATE_REQUESTED: 'MENU_UPDATE_REQUESTED',
  MENU_UPDATE_SUCCEEDED: 'MENU_UPDATE_SUCCEEDED',
  MENU_UPDATE_FILED: 'MENU_UPDATE_FILED',

  MENU_INSERT_REQUESTED: 'MENU_INSERT_REQUESTED',
  MENU_INSERT_SUCCEEDED: 'MENU_INSERT_SUCCEEDED',
  MENU_INSERT_FILED: 'MENU_INSERT_FILED',

  MENU_DELETE_REQUESTED: 'MENU_DELETE_REQUESTED',
  MENU_DELETE_SUCCEEDED: 'MENU_DELETE_SUCCEEDED',
  MENU_DELETE_FILED: 'MENU_DELETE_FILED',

  MENU_BYID_LOAD_REQUESTED: 'MENU_BYID_LOAD_REQUESTED',
  MENU_BYID_LOAD_SUCCEEDED: 'MENU_BYID_LOAD_SUCCEEDED',
  MENU_BYID_LOAD_FILED: 'MENU_BYID_LOAD_FILED',

  MENU_BYID_LOAD_INSERT_REQUESTED: 'MENU_BYID_LOAD_INSERT_REQUESTED',
  MENU_BYID_LOAD_INSERT_SUCCEEDED: 'MENU_BYID_LOAD_INSERT_SUCCEEDED',
  MENU_BYID_LOAD_INSERT_FILED: 'MENU_BYID_LOAD_INSERT_FILED',
}

export const getMenusAction = dispatch => {
  dispatch({
    type: actions.MENUS_LOAD_REQUESTED,
  })
}

export const getAllMenusParentsAction = dispatch => {
  dispatch({
    type: actions.MENUS_LOAD_ALL_PARENTS_REQUESTED,
  })
}

export const onSubmitInsertMenuFormAction = (dispatch, formMenu) => {
  dispatch({
    type: actions.MENU_INSERT_REQUESTED,
    payload: formMenu,
  })
}

export const onSubmitUpdateMenuFormAction = (dispatch, formMenu) => {
  dispatch({
    type: actions.MENU_UPDATE_REQUESTED,
    payload: formMenu,
  })
}

export const deleteMenuAction = (dispatch, id) => {
  dispatch({
    type: actions.MENU_DELETE_REQUESTED,
    payload: id,
  })
}

export const getMenuCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.MENU_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.MENU_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}
